"use strict";

export function GoUrl(that, path, parm,index) {
	goTempUrl(that, path, parm,index);
}

// 验证 是不是json
export function isJson(str) {
	let flag = false;
	if (typeof str == 'string') {
		try {
			var obj = JSON.parse(str);
			if (typeof obj == 'object' && obj) {
				flag = true;
			}

		} catch (e) {
			console.log('error：' + str + '!!!' + e);

		}
	}
	return flag;
}

export function GetRandom() {
	var chars = [
		"0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G",
		"H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X",
		"Y", "Z"
	];
	var maxLength = 4;
	var randomAccount = '';
	for (var i = 0; i < maxLength; i++) {
		var id = Math.ceil(Math.random() * 35);
		randomAccount += chars[id];
	}
	return randomAccount;
}

// 默认情况下jquery在处理textArea中文本时是会忽略掉回车符的，为了保留回车符选择使用<pre></pre>标签嵌套textArea中的内容，同时替换掉‘<’和'>'避免js注入。
// 不行测试失败 还是不能保留
export function CheckTextArea(value) {
	// var value = $("#textArea").val(); //获取textArea中的文字
	value = value.replace(/</g, "&lt;").replace(/>/g, "&gt;"); //替换'<'，'>'
	// var html = "<pre>" + value + "</pre>"; //创建pre元素
	// $(html).appendTo($("#result")); //添加的目标位置
	return value;
}

export function CheckInputData(value) {
	// var value = $("#textArea").val(); //获取textArea中的文字
	value = value.replace(" ", "");
	value = value.replace(/</g, "&lt;").replace(/>/g, "&gt;"); //替换'<'，'>'
	// var html = "<pre>" + value + "</pre>"; //创建pre元素
	// $(html).appendTo($("#result")); //添加的目标位置
	return value;
}

/*
给字符串增加 空格
tm 增加的字符
num 每几位
*/
export function AddStringSomething(str, tm, num) {
	console.log("前" + tm + "   " + num);
	if (tm == undefined || String(tm) == "null" || String(tm).length == 0) {
		tm = " ";
	}
	if (num == undefined || Number(num) == 0) {
		num = 4;
	}
	// console.log("后" + tm + "   " + num);
	var newstr = "";
	var oldlen = 0;
	oldlen = str.length;
	while (oldlen > 0) {
		if (oldlen > num) {
			newstr = newstr + str.substr(0, num) + tm;
			str = str.substr(num, str.length - num);
			oldlen = str.length;
		} else {
			newstr = newstr + str + tm;
			oldlen = 0;
		}
	}
	return newstr;
}

/**
 * 邮箱验证 */
export function checkStringByForm(value, type) {
	// console.log("格式校验 " + value);
	var flag = true;
	var reg = "";
	switch (type) {
		case "email":
			// reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/; //正则表达式
			// reg = /^[A-Za-zd]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
			// reg = /^[A-Za-zd]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
			reg = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/;
			break;
		case "zuoji":
			// 验证规则：座机。
			reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
			break;
		case "phone":
			// 验证规则：11位数字，以1开头。
			reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
			break;
		case "phone2":
			reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
			break;
		case "user":
			// 验证规则：字母、数字、下划线组成，字母开头，4-16位。
			reg = /^[a-zA-z]\w{3,15}$/;
			break;
		case "Eng":
			// 验证规则：只能是字母下划线开始。
			reg = /^[a-zA-Z][a-zA-Z0-9_]*$/;
			break;
		case "china":
			// 汉字
			reg = /^[\u4e00-\u9fa5]$/;
		default:
			flag = false;
			break;
	}
	if (value != "" && reg != "") {
		if (!reg.test(value)) {
			flag = false;
		} else {
			flag = true;
		}
	}
	// console.log(reg);
	// console.log("校验结果" + flag + "  " + reg.test(value));
	return flag;
}


// 删除特殊字符串
export function Word_Right_Delete(str) {
	str = String(str);
	str = str.replace(/\#/g, '');
	str = str.replace(/\%/g, '');
	str = str.replace(/\&/g, '');
	str = str.replace(/\+/g, '');
	str = str.replace(/\//g, '');
	str = str.replace(/\=/g, '');
	str = str.replace(/\?/g, '');
	str = str.replace(/\./g, '');
	str = str.replace(/\:/g, '');
	str = str.replace(/\"/g, '');
	// str = str.replace(/\^/g, ''); //这种方式只能对字母生效 只去掉一个
	// str = str.replace('^', '');  不好使用，只去掉一个
	var t = str.split("^");
	str = t.join("");
	str = str.replace(' ', '');
	// str = str.replace(/\n|\r|(\r\n)|(\u0085)|(\u2028)|(\u2029)/g, '');
	// add 2019-06-14 去掉,影响查询语句
	// str = str.replace('{', '');
	// str = str.replace('}', '');
	// str = str.replace('(', '');
	// str = str.replace(')', '');
	// console.log(str);
	return str;
}

export function RandomColor() {
	var r = Math.floor(Math.random() * 256);

	var g = Math.floor(Math.random() * 256);

	var b = Math.floor(Math.random() * 256);

	return "rgb(" + r + ',' + g + ',' + b + ")"; //所有方法的拼接都可以用ES6新特性`其他字符串{$变量名}`替换

}


function goTempUrl(that, path, parm,index) {
	// this.$refs.childrenmode.loadselect();

	// this.$router.push({
	//   name: 'compute',
	//   query: {
	//   t: +new Date() //保证每次点击路由的query项都是不一样的，确保会重新刷新view
	//   }});
	// console.log(this.$refs);
	var chars = [
		"0",
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"8",
		"9",
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z"
	];

	var maxLength = 4;
	var paramsAccount = "";
	for (var i = 0; i < maxLength; i++) {
		var id = Math.ceil(Math.random() * 35);
		paramsAccount += chars[id];
	}

	// res 为随机字符串,下面是跳转：
	// console.log(' 路径=' + path);
	// console.log(' 参数=' + parm);
	// console.log(' paramsAccount=' + paramsAccount);
	let o = {};
	// let pass_key='',pass_val='',pass_time='';
	
	// o.val=parm;
	o.id=index;
	o.time=paramsAccount;
	
	// pass_val=parm;
	// pass_time=paramsAccount;
	// console.log(parm);

	
	that.$router.push({
		path: "/" + path,
		query: o
	}).catch(err => err);
}

// 时间相关
export function dateFormat(fmt, date) {
	//author: meizz
	var o = {
		'M+': date.getMonth() + 1, //月份
		'd+': date.getDate(), //日
		'h+': date.getHours(), //小时
		'm+': date.getMinutes(), //分
		's+': date.getSeconds(), //秒
		'q+': Math.floor((date.getMonth() + 3) / 3), //季度
		S: date.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp('(' + k + ')').test(fmt))
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
	return fmt;
}

export function dateFormatbyChina(chinaStandard) {
	var date = new Date(chinaStandard);
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	var h = date.getHours();
	var minute = date.getMinutes();
	minute = minute < 10 ? ('0' + minute) : minute;
	// let time = y + '-' + m + '-' + d + ' ' + h + ':' + minute; //这里如果不需要小时 分  后边的可以不需要拼接
	let time = y + '-' + m + '-' + d; //这里如果不需要小时 分  后边的可以不需要拼接
	return time;
}

export function dateFormatEasybyChina(chinaStandard) {


	let time = '';
	if (chinaStandard.length == 8) {
		console.log('8位日期转换')
		console.log(chinaStandard);
		time = chinaStandard.substring(0, 4) + '-' + chinaStandard.substring(4, 6) + '-' + chinaStandard.substring(6,
			7);
	} else {
		var date = new Date(chinaStandard);
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		m = m < 10 ? ('0' + m) : m;
		var d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		time = y + '-' + m + '-' + d;
	}

	return time;
}

export function getNowDateTime() {
	var date = new Date();
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	var h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	var minute = date.getMinutes();
	minute = minute < 10 ? ('0' + minute) : minute;
	var ss = date.getSeconds();
	ss = ss < 10 ? ('0' + ss) : ss;
	let time = y + '-' + m + '-' + d + '-' + h + '-' + minute + '-' + ss;
	return time;
}

export function dateFormatToChina(first_day, second_time) {
	if (typeof(first_day) == 'undefined' || first_day == '') {
		var date = new Date();
		var ty = date.getFullYear();
		var tm = date.getMonth() + 1;
		tm = tm < 10 ? ('0' + tm) : tm;
		var td = date.getDate();
		td = td < 10 ? ('0' + td) : td;
		first_day = ty + '-' + tm + '-' + td;
	}
	// console.log(first_day);
	let y = '',
		m = '',
		d = '',
		h = '',
		mm = '',
		ss = '';
	y = first_day.substring(0, 4);
	m = first_day.substring(5, 7);
	d = first_day.substring(8, 10);
	// console.log('年=' + y + ' 月=' + m + ' 日=' + d);
	let arr = second_time.split(':');
	if (arr.length > 0) {
		h = arr[0];
		mm = arr[1];
		ss = arr[2];
	}
	return new Date(y, m, d, h, mm, ss);
}

export function dateFormatToChina2(datetime) {
	let y = '',
		m = '',
		d = '',
		h = '',
		mm = '',
		ss = '';

	// console.log(datetime);
	let first_day = '',
		second_time = '';
	first_day = datetime.substring(0, 10);
	second_time = datetime.substring(11, 19);
	// console.log('='+first_day);
	// console.log('='+second_time);
	y = first_day.substring(0, 4);
	m = first_day.substring(5, 7);
	d = first_day.substring(8, 10);
	// console.log('年=' + y + ' 月=' + m + ' 日=' + d);
	let arr = second_time.split(':');
	if (arr.length > 0) {
		h = arr[0];
		mm = arr[1];
		ss = arr[2];
	}
	return new Date(y, m, d, h, mm, ss);
}

/* 生成唯一ID */
export function UUID() {
	var d = new Date().getTime();
	if (window.performance && typeof window.performance.now === "function") {
		d += performance.now(); //use high-precision timer if available
	}
	var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
	return uuid.toUpperCase();
}


function s2ab(s) {
	// 字符串转字符流
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);
	for (var i = 0; i !== s.length; ++i) {
		view[i] = s.charCodeAt(i) & 0xff;
	}
	return buf;
}

function getCharCol(n) {
	// 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
	let s = "";
	let m = 0;
	while (n > 0) {
		m = (n % 26) + 1;
		s = String.fromCharCode(m + 64) + s;
		n = (n - m) / 26;
	}
	return s;
}

function fixdata(data) {
	// 文件流转BinaryString
	var o = "";
	var l = 0;
	var w = 10240;
	for (; l < data.byteLength / w; ++l) {
		o += String.fromCharCode.apply(
			null,
			new Uint8Array(data.slice(l * w, l * w + w))
		);
	}
	o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
	return o;
}

function countTime() {
	//获取当前时间
	var date = new Date();
	var now = date.getTime();
	//设置截止时间
	// var str="2019/02/28 00:00:00";
	var str = lastdate;
	var endDate = new Date(str);
	var end = endDate.getTime();

	//时间差
	var leftTime = end - now;
	//定义变量 d,h,m,s保存倒计时的时间
	var d, h, m, s;
	if (leftTime >= 0) {
		d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
		h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
		m = Math.floor((leftTime / 1000 / 60) % 60);
		s = Math.floor((leftTime / 1000) % 60);
	}
	//将倒计时赋值到div中
	document.getElementById('_d').innerHTML = d + '天';
	document.getElementById('_h').innerHTML = h + '时';
	document.getElementById('_m').innerHTML = m + '分';
	document.getElementById('_s').innerHTML = s + '秒';
	//递归每秒调用countTime方法，显示动态时间效果
	// setTimeout(countTime, 1000);
}

function getNowAddTreeFormatDate() {
	var date = new Date();
	date.setDate(date.getDate() + 3); //获取3天后的日期
	var seperator1 = '-';
	var seperator2 = ':';
	var month = date.getMonth() + 1;
	var monthStr;
	var day = date.getDate();
	var dayStr;
	if (month >= 1 && month <= 9) {
		monthStr = '0' + month.toString();
	} else {
		monthStr = month.toString();
	}
	if (day >= 0 && day <= 9) {
		dayStr = '0' + day.toString();
	} else {
		dayStr = day.toString();
	}
	// var currentdate = date.toISOString(); //date.getFullYear() + seperator1 + month + seperator1 + dayStr + 'T00:00:00+08:00'
	var currentdate = date.toDateString();
	console.log('三天后日期 ' + currentdate);
	return currentdate;
}
